import stylesheet from './SuccessClaim.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTSuccessClaim extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('success-claim');
        element.innerHTML = `
            <span class="claim"></span>
            <span class="claim-value"></span>
        `;
        this.cloneDefaultSlotContentIntoContainer(element.querySelector('.claim-value'));
        this.cloneSlotContentIntoContainer(element.querySelector('.claim'), 'claim');
        return element;
    }

}

customElements.define('nxt-story-claim', NXTSuccessClaim);
